import clsx from "clsx";
import { useState } from "react";
import Image from "@Components/Image";
import { useCustomer } from "@wff/hooks/useCustomer";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";
import { AccountNavLinks } from "./AccountNavLinks";
import { NavLink } from "./NavLink";
import classes from "./Header.module.scss";

interface AccountMenuProps {
  className?: string;
  isNavExpanded?: boolean;
  joinText?: string;
  profileImage?: {
    url?: string;
  };
  onAccountNavLinkClick?: () => void;
}

export const AccountMenu = ({
  className,
  profileImage,
  joinText,
  isNavExpanded,
  onAccountNavLinkClick,
}: AccountMenuProps) => {
  const { customerInfo } = useCustomer();
  const currentLocale = useAppSelector(localeSelector);
  const [showOptions, setShowOptions] = useState(false);
  const toggleCustomerOptions = () =>
    setShowOptions((showOptions) => !showOptions);

  const handleAccountNavClick = () => {
    toggleCustomerOptions();
    onAccountNavLinkClick?.();
  };

  return customerInfo.firstName ? (
    <div className={clsx(classes["customer-info-section"], className)}>
      <div
        onClick={toggleCustomerOptions}
        className={classes["customer-info-section-user"]}
        onKeyDown={toggleCustomerOptions}
      >
        <Image
          src={`${profileImage?.url}?w=24&h=24`}
          width={24}
          height={24}
          alt="profile"
        />
        <span className={classes["customer-info-section-username"]}>
          {customerInfo.firstName}
        </span>
      </div>
      <AccountNavLinks
        showOptions={showOptions}
        onNavLinkClick={handleAccountNavClick}
      />
    </div>
  ) : (
    <NavLink
      className={classes["customer-info-link"]}
      href={`/${currentLocale.languageCode}/account/login`}
    >
      <Image
        src={`${profileImage?.url}?w=24&h=24`}
        width={isNavExpanded ? 14 : 24}
        height={isNavExpanded ? 14 : 24}
        alt="profile"
      />
      <p className={classes["customer-info-section-session"]}>{joinText}</p>
    </NavLink>
  );
};

AccountMenu.defaultProps = {
  className: "",
  isNavExpanded: false,
  joinText: "",
  profileImage: {},
};
